import _ from 'lodash';
import moment from 'moment';
import { ISubscriptionInDTO } from '../repository/jago/model/input/ISubscriptionInDTO';
import { IVarInDTO } from '../repository/jago/model/input/IVarInDTO';
import { IWalletSubscriptionInDTO } from '../repository/jago/model/input/IWalletSubscriptionInDTO';
import { ISegmentTypeEnum } from '../repository/jago/model/output/ISegmentTypeEnum';
import { Roles } from '../services/PermissionService/PermissionConstants';
import { RoleEntities } from '../services/PermissionService/PermissionsParser';
import translations from '../translations/i18next';
import { ActivationBaselineSubscription, activationBaselineSubscriptions } from './activationBaselineSubscriptions';
import { VarPartnerLevel, VarPreferredPartnerLevel, VarRegisteredPartnerLevel } from './../codec/varInDTODecoder';

export default class Utils {
  public static getAvailableISEOCompanies(): ISEOCompanyInfo[] {
    const markets  = [
      {name: "ISEO Serrature", country: "Italy"},
      {name: "ISEO France", country: "France"},
      {name: "ISEO Deutschland", country: "Germany"},
      {name: "ISEO Ibérica", country: "Spain"},
      {name: "ISEO Middle East", country: "U.A.E"},
      {name: "ISEO Asia Pacific", country: "Malaysia"},
      {name: "ISEO (Beijing) Security Technology", country: "P.R.C"},
      {name: "Iseo South Africa", country: "South Africa"},
      {name: "Feroneria Prod", country: "Romania"},
      {name: "Sofia Locks", country: "Italy"},
      {name: "Microhard", country: "Italy"},
      {name: "ISEO Colombia", country: "Colombia"},
      {name: "Iseo Perú", country: "Perú"},
      {name: "ISEO UKI", country: "U.K"},
    ];

    return markets;
  }

  public static getAvailableCountries(): CountryInfo[] {
    const countries = [
      "IT-Italy", "AL-Albania", "AM-Armenia", "AZ-Azerbaijan", "BE-Belgium",
      "BG-Bulgaria", "BIH-Bosnia-Erzegovina", "BY-Bielorussia", "CY-Cyprus", "CZ-Czech Republic",
      "DK-Denmark", "EW-Estonia", "FIN-Finland", "FL-Liechtenstein", "GB-United Kingdom",
      "GBM-Isola di Man", "GE-Georgia", "GR-Greece", "HU-Hungary", "HR-Croatia",
      "IL-Israel", "IRL-Ireland", "IS-Iceland", "KAZ-Kazakhstan", "KG-Kirghizistan",
      "KOS-Kosovo", "LU-Luxembourg", "LT-Lithuania", "LV-Latvia", "M-Malta",
      "MK-Macedonia", "MNE-Montenegro", "MOL-Rupublic of Moldavia", "NO-Norway", "NL-Netherlands",
      "PL-Poland", "RL-Lebanon", "RUS-Russia", "SE-Sweden", "SK-Slovakia",
      "SLO-Slovenia", "SRB-Serbia", "TJ-Tajikistan", "TM-Turkmenistan", "TR-Turkey",
      "UA-Ukraine", "UZ-Uzbekistan", "RO-Romania", "AUS-Australia", "BRU-Brunei",
      "BUR-Myanmar", "HK-Hong Kong", "JP-Japan", "KH-Cambodia", "KOR-South Korea",
      "LAO-Laos", "MAC-Macau", "MAL-Malaysia", "MNG-Mongolia", "NZ-New Zealand",
      "PG-New Guinea", "PRC-China", "RC-Taiwan-Formosa", "RI-Indonesia", "RP-Philippines",
      "SGP-Singapore", "TH-Thailand", "VN-Vietnam", "AG-Antigua and Barbuda", "AO-Antille Olandesi",
      "AW-Aruba", "BH-Belize", "BOL-Bolivia", "BR-Brazil", "BS-Bahamas",
      "CU-Cuba", "CDN-Canada", "CO-Colombia", "CR-Costa Rica", "CW-Curaçao",
      "DOM-Dominican Republic", "EC-Ecuador", "ES-El Salvador", "FK-Falkland Islands", "GCA-Guatemala",
      "GS-South Georgia", "GUY-Guyana", "HON-Honduras", "JA-Jamaica", "KY-Cayman",
      "MEX-Mexico", "NIC-Nicaragua", "PA-Republic of Panama", "PE-Peru", "PUE-Puerto Rico",
      "PY-Paraguay", "RA-Argentine", "RCH-Chile", "RH-Haiti", "ROU-Uruguay",
      "SME-Suriname", "TT-Trinidad&Tobago", "TUC-Turks e Caicos Islands", "USA-United States of America", "YV-Venezuela",
      "ADN-Yemen", "AFG-Afghanistan", "AN-Angola", "AV-Alto Volta", "BEN-Benin",
      "BF-Burkina Faso", "BI-Guinea-Bissau", "BRN-Bahrain", "CI-Ivory Coast", "CON-Republic of Congo",
      "DJ-Djibouti", "EAK-Kenya", "EAT-Tanzania", "ERT-Eritrea", "ET-Egypt",
      "ETH-Ethiopia", "GAB-Gabon", "GH-Ghana", "GQ-Guinea Equatoriale", "HKJ-Jordan",
      "IR-Iran", "IRQ-Iraq", "JOR-Cisgiordania", "KWT-Kuwait", "LB-Liberia",
      "LBN-Libano", "MOC-Mozambique", "NCL-New Caledonia", "OMA-Sultanato of Oman", "PK-Pakistan",
      "QAT-Qatar", "RM-Madagascar", "RMM-Republic of Mali", "RU-Burundi", "RWA-Ruanda",
      "SA-Saudi Arabia", "SL-Sierra Leone", "SN-Senegal", "SU-Sudan", "SYR-Syria",
      "TC-Cameroon", "TG-Togo", "UAE-United Arab Emirates", "UG-Uganda", "WAG-Gambia",
      "WAN-Nigeria", "ZM-Zambia", "ZRE-Zaire", "BD-Bangladesh", "CL-Sri Lanka",
      "IND-India", "LAR-Libya", "ZA-South Africa", "NAM-Namibia", "SD-Swaziland",
      "ZW-Zimbabwe", "Dorma ZA", "DE-Deutschland", "AT-Austria", "CH-Switzerland",
      "FR-France", "ISR-Ile de Reunion", "GUA-Guadalupe", "MQ-Martinique", "NC-Nuova Caledonia",
      "GF-French Guinea", "PF-French Polinesia", "CF-central Africa Republic", "IM-Mauritius Islands", "DZ-Algeria",
      "MA-Morocco", "MRT-Mauritania", "TN-Tunisia", "ES-Spain", "GIB-Gibraltar",
      "AND-Andorra", "IC-Canarie", "PT-Portugal"
    ];      
    return countries.map(e=>{return {id:e,value:e}});
   }
  
  public static activationBaselineSubscriptions: ActivationBaselineSubscription[] = activationBaselineSubscriptions;
  
  public static hasEngineSubscription(subscriptions: IWalletSubscriptionInDTO[]) {
    return _.some(subscriptions, s => {
      if (s.subscription) {
        return _.includes(s.subscription.sku, '024S');
      }
      return false;
    });
  }

  public static getBaselineSubscriptionsFromName(subscriptions: ISubscriptionInDTO[], baselineSubscriptionName: string) {
    const baseLineSub = this.activationBaselineSubscriptions.filter(e=>e.name===baselineSubscriptionName);
    if (!baseLineSub.length) {
      return [];
    }
    const skuRule = baseLineSub[0].skuRule;

    return _.filter(subscriptions, s => {
      if (_.startsWith(s.sku, 'IS')) {
        return s.resource === 'DOMAIN' && s.sku.includes(skuRule.IS);
      }
      return s.resource === 'DOMAIN' && s.sku.includes(skuRule.SL);
    });
  }

  public static isUnboundedAddon(subscription: ISubscriptionInDTO) {
    return subscription.resource!=='DOMAIN'&&(subscription.mainTier===null);
  }

  public static isWalletMainTierSubscription(s: IWalletSubscriptionInDTO) {
    return this.isMainTierSubscription(s.subscription);
  }

  public static isMainTierSubscription(s: ISubscriptionInDTO) {
    return s.resource === "DOMAIN";
  }

  public static isPluginSubscription(s: ISubscriptionInDTO) {
    return s.mainTier != null;
  }

  public static formatCreditsIn(credits?: number): number {
    if (!credits) {
      return 0;
    }
    return credits / 100;
  }

  public static formatCreditsOut(credits: number): number {
    return Math.round(credits * 100);
  }

  public static formatServicePrice(price: number): number {
    return Math.round(price * 100) / 100;
  }

  public static isEmptyPrice(price: number | null | undefined): boolean {
    return price === null || price === undefined || Number.isNaN(price);
  }

  public static generateSFDCCRMLink(SFDCId: string): SFDCCRMLinks {
    const splittedId = _.split(SFDCId, '-');
    const linkId = _.last(splittedId);
    return {
      SFCDLinkBasic: `https://iseo.force.com/corporate/s/global-search/${linkId}`,
      SFCDLinkPremium: `https://iseo.my.salesforce.com/_ui/search/ui/UnifiedSearchResults?searchType=2&str=${linkId}#`
    };
  }

  public static generateSofiaPDLink(SFDCId: string): string {
    const splittedId = _.split(SFDCId, '-');
    const linkId = _.first(splittedId);
    return `https://sofialocks.pipedrive.com/deal/${linkId}`;
  }

  public static getHardwareType(s: string) {
    switch (s) {
      case 'smartlock':
        return 'SMARTLOCK';
      case 'gateway':
        return 'HYPERGATE PRO';
      case 'atlas':
        return 'ATLAS';
      default:
        return s;
    }
  }

  public static getGatewayVersion(s: string) {
    const version =  s ? _.split(s, 'SW: ')[1] : '---';
    return version || s;
  }

  // Map solution enum values to translation keys
  public static getSolutionTranslationKey(value: string): string {
    const keyMap: { [key: string]: string } = {
      'LUCKEY': 'credits.customerPlantSolutionLuckey',
      'ARGO': 'credits.customerPlantSolutionArgo',
      'FLEX': 'credits.customerPlantSolutionFlex',
      'LWC': 'credits.customerPlantSolutionLwc',
      'ATG': 'credits.customerPlantSolutionAtg',
      'VAR': 'credits.customerPlantSolutionVar',
      'MECHANIC': 'credits.customerPlantSolutionMechanic',
      'OTHER': 'credits.customerPlantSolutionOther',
      'V364_CLASSIC': 'credits.customerPlantSolutionV364Classic',
    };
    return keyMap[value] || value;
  }

  public static getCurrencyTranslation(value: string): string {
    const keyMap: { [key: string]: string } = {
      'EUR': '€',
      'USD': '$',
      'GBP': '£',
      'CHF': 'CHF',
    };
    return keyMap[value] || value;
  }

  // Map platform enum values to translation keys
  public static getPlatformTranslationKey(value: string): string {
    const keyMap: { [key: string]: string } = {
      'IRIS': 'credits.customerPlantPlatformIris',
      'IRIS_ARGO': 'credits.customerPlantPlatformIrisArgo',
      'ARGO': 'credits.customerPlantPlatformArgo',
    };
    return keyMap[value] || value;
  }

  // Map type enum values to translation keys

  public static getTypeTranslationKey(value: string): string {
    const keyMap: { [key: string]: string } = {
      'PREPROD_PILOT': 'credits.customerPlantTypePreprodPilot',
      'PREPROD_PRODUCTION': 'credits.customerPlantTypePreprodProduction',
      'PROD_PILOT': 'credits.customerPlantTypeProdPilot',
      'PROD_PRODUCTION': 'credits.customerPlantTypeProdProduction',
      'PROD_DISABLED': 'credits.customerPlantTypeProdDisabled',
      'DEMO': 'credits.customerPlantTypeDemo',
      'DEAD': 'credits.customerPlantTypeDead',
    };
    return keyMap[value] || value;
  }

  // Map management enum values to translation keys
  public static getManagementTranslationKey(value: string): string {
    const keyMap: { [key: string]: string } = {
      'ON_PREMISE_CLASSIC': 'credits.customerPlantManagementOnPremiseClassic',
      'ON_PREMISE_VM_NATIVE': 'credits.customerPlantManagementOnPremiseVmNative',
      'ON_PREMISE_VM_DOCKER_BASED': 'credits.customerPlantManagementOnPremiseVmDockerBased',
      'ON_PREMISE_CONTAINER': 'credits.customerPlantManagementOnPremiseContainer',
      'ON_PREMISE_OTHER': 'credits.customerPlantManagementOnPremiseOther',
      'SAAS_AZURE': 'credits.customerPlantManagementSaasAzure',
      'SAAS_AWS': 'credits.customerPlantManagementSaasAws',
      'OTHER': 'credits.customerPlantManagementOther',
    };
    return keyMap[value] || value;
  }

  public static getCustomerCategoryTranslationKey(value: string): string {
    const keyMap: { [key: string]: string } = {
      'CUSTOMER': 'forms.customer',
      'SIMPLIFIED_CUSTOMER': 'forms.simplifiedCustomer',
    };
    return keyMap[value] || value;
  }

  // Map modality enum values to translation keys
  public static getModalityTranslationKey(value: string): string {
    const keyMap: { [key: string]: string } = {
      'PERIODIC': 'credits.customerPlantModalityPeriodic',
      'CREDITS': 'credits.customerPlantModalityCredits',
    };
    return keyMap[value] || value;
  }

  // Get translated label for solution
  public static getTranslatedSolutionLabel(value: string): string {
    const translationKey = Utils.getSolutionTranslationKey(value);
    return translations.t(translationKey);
  }

  // Get translated label for platform
  public static getTranslatedPlatformLabel(value: string): string {
    const translationKey = Utils.getPlatformTranslationKey(value);
    return translations.t(translationKey);
  }

  // Get translated label for type
  public static getTranslatedTypeLabel(value: string): string {
    const translationKey = Utils.getTypeTranslationKey(value);
    return translations.t(translationKey);
  }

  // Get translated label for management
  public static getTranslatedManagementLabel(value: string): string {
    const translationKey = Utils.getManagementTranslationKey(value);
    return translations.t(translationKey);
  }

  // Get translated label for modality
  public static getTranslatedModalityLabel(value: string): string {
    const translationKey = Utils.getModalityTranslationKey(value);
    return translations.t(translationKey);
  }

  public static getTranslatedCustomerCategoryLabel(value: string): string {
    const translationKey = Utils.getCustomerCategoryTranslationKey(value);
    return translations.t(translationKey);
  }
}

export interface ISEOCompanyInfo {
  name: string;
  country: string;
}

export interface CountryInfo {
  id: string;
  value: string;
}

export type { ActivationBaselineSubscription };

export interface SFDCCRMLinks {
  SFCDLinkBasic: string;
  SFCDLinkPremium: string;
}


export function getGatewayDeploymentStatusColor(status: string) {
  switch (status) {
    case 'PENDING':
      return 'gray';
    case 'DONE':
      return 'forestgreen';
    case 'IN_PROGRESS':
      return 'darkorange';
    case 'ERROR':
      return 'orangered';
  }
}

export function getWalletStatusColor(status: string) {
  switch (status) {
    case 'PENDING':
      return 'gray';
    case 'ACTIVE':
      return 'forestgreen';
    case 'READY_TO_ACTIVATE':
      return 'darkorange';
    case 'DISABLED':
      return 'orangered';
  }
}

export function getActivationStatusColor(status: string) {
  switch (status) {
    case 'DRAFT':
      return 'gray';
    case 'UNDER_REVIEW':
      return 'orange';
    case 'REJECTED':
      return 'orangered';
    case 'PROCESSING':
      return 'darkorange';
    case 'CREATED':
      return 'dodgerblue';
    case 'INVOICED':
      return 'forestgreen';
    case 'ACTIVE':
      return 'lightseagreen';
    case 'DELETED':
      return 'orangered';
  }
}

export function getOpportunitiesStatusColor(status: string) {
  switch (status) {
    case 'DRAFT':
      return 'cadetblue';
    case 'ON_APPROVAL':
      return 'darkorange';
    case 'APPROVED':
      return 'lightseagreen';
    case 'CANCELLED':
      return 'gray';
    case 'REJECTED':
      return 'orangered';
    case 'WON':
      return 'forestgreen';
    case 'LOST':
      return 'darkslategrey';
  }
}

export function getCustomerContractStatusColor(status: string) {
  switch (status) {
    case 'ACTIVE':
      return 'lightseagreen';
    case 'NOT_ACTIVE':
      return 'gray';
    case 'CANCELLED':
      return 'orangered';
    default:
      return 'gray';
  }
}

export function getCustomerContractServiceStatusColor(status: string) {
  switch (status) {
    case 'ACTIVE':
    case 'DONE':
      return 'lightseagreen';
    case 'WAITING_FOR_ACTIVATION':
    case 'WAITING_TO_BE_DONE':
    case 'WORK_IN_PROGRESS':
    case 'PAUSED':
      return 'orange';
    case 'INACTIVE':
      return 'gray';
    case 'CANCELLED':
      return 'orangered';
    default:
      return 'gray';
  }
}

export function getRechargeStatusColor(status: string) {
  switch(status) {
    case 'TO_BE_MANAGED':
      return 'gray';
    case 'TAKEN_CHARGE':
      return 'darkorange';
    case 'REQUEST_TO_DELETE':
      return 'orangered';
    case 'SELLOUT_ORDER_GENERATED':
      return 'dodgerblue';
    case 'REJECTED':
      return 'orangered';
    case 'SCRATCHCARD_CREATED':
      return 'cadetblue';
    case 'INVOICED':
      return 'forestgreen';
    case 'WALLET_RECHARGED':
      return 'green';
  }
}

export function decodeUnicode(input) {
  // Regular expression to find characters in the form '&#xxxx'
  const regex = /&#(\d+);/g;

  // Use the replace method with a callback function
  return input.replace(regex, (match, charCode) => {
    // Convert the matched character code to the actual character
    return String.fromCharCode(parseInt(charCode, 10));
  });
}

export interface IVarUserRole {
  id: number;
  name: string;
  label: string;
};

export const VAR_USERS_ROLES: IVarUserRole[] = [
  {
    id: 51,
    name: Roles.ROLE_VASHO_VAR_ADMIN,
    label: "Admin",
  },
  {
    id: 72,
    name: Roles.ROLE_VASHO_VAR_SUPPORT,
    label: "Support",
  },
  {
    id: 73,
    name: Roles.ROLE_VASHO_VAR_SALES_MANAGER,
    label: "Sales Manager",
  },
  {
    id: 74,
    name: Roles.ROLE_VASHO_VAR_SALES_REPRESENTATIVE,
    label: "Sales Representative",
  },
]

export const VAR_USERS_ROLES_STAGING: IVarUserRole[] = [
  {
    id: 26,
    name: Roles.ROLE_VASHO_VAR_ADMIN,
    label: "Admin",
  },
  {
    id: 35,
    name: Roles.ROLE_VASHO_VAR_SUPPORT,
    label: "Support",
  },
  {
    id: 36,
    name: Roles.ROLE_VASHO_VAR_SALES_MANAGER,
    label: "Sales Manager",
  },
  {
    id: 37,
    name: Roles.ROLE_VASHO_VAR_SALES_REPRESENTATIVE,
    label: "Sales Representative",
  },
]

export const USER_ROLES_NAME_MAPPING: any = {
  ROLE_VASHO_SOFIA_ADMIN: 'Admin Sofia',
  ROLE_VASHO_GLOBAL_SEGMENT_LEADER: 'Global Segment Leader',
  ROLE_VASHO_GLOBAL_SALES_OPERATION_MANAGER: 'Global Sales Operation Manager',
  ROLE_VASHO_SALES_OPERATION_MANAGER: 'Sales Operation Manager',
  ROLE_VASHO_MARKET_LEADER: 'Market Leader',
  ROLE_VASHO_EUSM: 'End-user Sales Manager',
  ROLE_VASHO_KAM: 'KAM',
  ROLE_VASHO_GLOBAL_SOC_MANAGER: 'Global SOC Manager',
  ROLE_VASHO_LOCAL_SOC_MANAGER: 'Local SOC Manager',
  ROLE_VASHO_VAR_ADMIN: 'VAR Admin',
  ROLE_VASHO_VAR_SALES_MANAGER: 'VAR Sales Manager',
  ROLE_VASHO_VAR_SALES_REPRESENTATIVE: 'VAR Sales Representative',
  ROLE_VASHO_VAR_SUPPORT: 'VAR Support',
  ROLE_MKS_MANAGER: 'MKS Manager',
  ROLE_VASHO_SALES_SOC: 'SOC Manager and Sales Ops',
  ROLE_VASHO_DEVELOPER_ADMIN: 'Developer Admin',
}

export const VAR_USER_ROLES_NAME_MAPPING: any = {
  ROLE_VASHO_VAR_ADMIN: 'Admin',
  ROLE_VASHO_VAR_SALES_MANAGER: 'Sales Manager',
  ROLE_VASHO_VAR_SALES_REPRESENTATIVE: 'Sales Representative',
  ROLE_VASHO_VAR_SUPPORT: 'Support',
}

export function getRoleReadableName(role,isVar=false) {
  if (isVar) {
    if (VAR_USER_ROLES_NAME_MAPPING[role]) {
      return VAR_USER_ROLES_NAME_MAPPING[role];
    }
  }
  else {
    if (USER_ROLES_NAME_MAPPING[role]) {
      return USER_ROLES_NAME_MAPPING[role];
    }
  }
  return role;
}

export function groupPermissionsByEntity(permissions) {

  if (!permissions || _.isEmpty(permissions)) return [];
  const groupedPermissions = {};
  const entities = _.keys(RoleEntities);

  // Initialize each entity with an empty array to collect actions
  entities.forEach(entity => {
    groupedPermissions[entity] = [];
  });

  permissions.forEach(permission => {
    // Check each known entity to see if it is a prefix of the permission
    entities.forEach(entity => {
      if (permission.startsWith(entity + "_")) {
        // Extract the action by removing the entity and underscore
        const action = permission.slice(entity.length + 1);
        groupedPermissions[entity].push(action);
      }
    });
  });
  return _.pickBy(groupedPermissions, actions => !_.isEmpty(actions));

}

export function calculateNextRechargeDate(totalCredits, burnRate) {
  if (burnRate === 0) {
    return moment('2999-12-31').valueOf();
  }
  const days = totalCredits / burnRate;
  return moment().add(days, 'days').valueOf();
}

export function calculateTotalElementsStatusColor(elements: number, maxElements: number): string {
  if (!maxElements) return '#3f3f3f';
  const ratio = (elements / maxElements) * 100;
  if (ratio > 80) {
    return 'red';
  } else if (ratio > 60) {
    return 'chocolate';
  }
  
  return '#3f3f3f';
}

export function getDisplayCredits(credits) {
  return credits / 100;
}

export function getMonthlyBurnRate(burnRate) {
  return _.ceil(((burnRate / 100) * 365) / 12);
}

export function getVarPartnerLevel(VAR: IVarInDTO) {
  const varActiveBadges = getVarActiveBadges(VAR);
  const hasContractSigned = varActiveBadges.includes(0);
  
  if (!hasContractSigned) {
    return VarPartnerLevel.CANDIDATE_VAR;
  }
  
  const currentVarLevel = _.size(varActiveBadges);
  if (currentVarLevel >= VarPreferredPartnerLevel) {
    return VarPartnerLevel.PREFERRED_PARTNER;
  }
  if (currentVarLevel >= VarRegisteredPartnerLevel) {
    return VarPartnerLevel.REGISTERED_PARTNER;
  }
  
  return VarPartnerLevel.CANDIDATE_VAR;
}

export function getVarActiveBadges(VAR: IVarInDTO) {
  const activeBadgesIndexes = []
  if (VAR.agreementFileExpirationDate && moment(VAR.agreementFileExpirationDate).startOf('day').isAfter(moment().startOf('day'))) {
    activeBadgesIndexes.push(0); // Agreement file badge
  }
  if (VAR.rebateLetterFileExpirationDate && moment(VAR.rebateLetterFileExpirationDate).startOf('day').isAfter(moment().startOf('day'))) {
    activeBadgesIndexes.push(1);
  }
  if (VAR.lastTrainingDate && VAR.lastTrainingDateExpirationDate && moment(VAR.lastTrainingDateExpirationDate).startOf('day').isAfter(moment().startOf('day'))) {
    activeBadgesIndexes.push(2); // Last training date badge
  }
  if (VAR.demoKitOrderNumber && VAR.demoKitPurchaseDate) {
    activeBadgesIndexes.push(3); // Demo kit badge
  }
  if (VAR.hasQuotationRequested) {
    activeBadgesIndexes.push(4); // Quotation requested badge
  }
  if (VAR.hasActiveCustomer) {
    activeBadgesIndexes.push(5); // Active customer badge
  }
  return activeBadgesIndexes;
}

export function isSegmentTypeDeprecated(item: ISegmentTypeEnum) {
  return (
    item === ISegmentTypeEnum.WORKING_SPACES || 
    item === ISegmentTypeEnum.LIVING || 
    item === ISegmentTypeEnum.RETAIL || 
    item === ISegmentTypeEnum.UNIVERSITIES || 
    item === ISegmentTypeEnum.LEISURE || 
    item === ISegmentTypeEnum.HOSPITAL
  )
}

export function isDemoCustomer(customerName: string): boolean {
  if (!customerName) return false;
  return customerName.toLowerCase().includes('[demo]');
}
